export const SOLD_TO_COMPARE = 'SoldTo';
export const PAYER_COMPARE = 'Payer';
export const ACCOUNT_PAYER_ALL = 'PayerAll';
export const INV_LIST_REQ_BEGIN_DATE = '01-01-1900';
export const INV_LIST_REQ_END_DATE = '01-01-9999';
export const SUCCESS = 'Success';
export const DEFAULT_DEPOSIT_REASON_CODE = '055';
